import { render, staticRenderFns } from "./dataPannel.vue?vue&type=template&id=1b2c8aae&scoped=true"
import script from "./dataPannel.vue?vue&type=script&lang=js"
export * from "./dataPannel.vue?vue&type=script&lang=js"
import style0 from "./dataPannel.vue?vue&type=style&index=0&id=1b2c8aae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2c8aae",
  null
  
)

export default component.exports